import React from 'react'
import Nav from './Nav'

const Portfolio = () => {
    return (
        <>
            <main id="main" class="bg-img">
                <div id="bgImg">
                    <div class="container">

                        <Nav />

                        <div class="content">
                            <div class=" projects">
                                <span>Portfolio</span>
                                <h1>Portfolio</h1>

                                <div class="wrapper">
                                    <div class="photobanner">
                                        <a href="https://aminkhaled.github.io/Cars-brands/" target="_blank"><img class="first"
                                            src="img/1.png" alt="" /></a>
                                        <a href="https://aminkhaled.github.io/Bankist-landing-page/" target="_blank"><img
                                            src="img/3.png" alt="" /></a>
                                        <a href="https://aminkhaled.github.io/Tasty-Food/" target="_blank"><img src="img/4.png"
                                            alt="" /></a>
                                        <a href="https://aminkhaled.github.io/ClothesEcommerce/" target="_blank"><img
                                            src="img/7.png" alt="" /></a>
                                        <a href="https://aminkhaled.github.io/Shopping-Site/" target="_blank"><img
                                            src="img/8.png" alt="" /></a>
                                        <a href="https://aminkhaled.github.io/Maadi-gym/" target="_blank"><img src="img/9.png"
                                            alt="" /></a>
                                        <a href="https://aminkhaled.github.io/Portfolio/" target="_blank"><img src="img/13.png"
                                            alt="" /></a>
                                        <a href="https://aminkhaled.github.io/Fooseshoes/" target="_blank"><img src="img/14.png"
                                            alt="" /></a>
                                        <a href="https://aminkhaled.github.io/OmniFood/" target="_blank"><img src="img/19.png"
                                            alt="" /></a>
                                        <a href="https://aminkhaled.github.io/Axit/" target="_blank"><img src="img/20.png"
                                            alt="" /></a>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="social-media" style={{marginTop: "40px"}}>
                            <a href="https://www.facebook.com/Perfect-151150445074122"><img src="img/facebook.png"/></a>
                            <a
                                href="https://www.instagram.com/perfect94446783/?fbclid=IwAR14fVz3P2rQ5x8Y8sAlERhd1ldCJhGDPt8M1KAoDsH3sO-y_vDRKNy4Yqg"><img
                                    src="img/instagram.png"/></a>
                            <a href="https://www.youtube.com/channel/UC-RBwShQdGVl8aQCo2tyHnA/featured"><img
                                src="img/youtube.png"/></a>

                            <span>SOCIAL MEDIA</span>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default Portfolio
